import type { AdmissionRecheckScope, DocumentStats } from "../../../lib/corpusApi";

// The document scopes batch jobs over existing corpus documents share.

export interface DocumentScopeOption {
  value: AdmissionRecheckScope;
  label: string;
}

export const DOCUMENT_SCOPE_OPTIONS: DocumentScopeOption[] = [
  { value: "ingested", label: "Ingested" },
  { value: "pending_ready", label: "Pending & ready" },
  { value: "all", label: "All" },
];

/** How many documents a scope currently covers, from the Documents stats endpoint — never includes
 *  revoked sources. Null until the stats have loaded. */
export function countDocumentsInScope(
  stats: DocumentStats | null,
  scope: AdmissionRecheckScope
): number | null {
  if (!stats) return null;
  switch (scope) {
    case "ingested":
      return stats.ingested;
    case "pending_ready":
      return stats.pending + stats.ready;
    case "all":
      return stats.pending + stats.ready + stats.ingested;
  }
}
